import { request } from "../axios/request";

export const getGatewaysService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/gateways", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const getSingleGatewaysService = (id = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/gateways/" + id, getState(), {
        method: "GET",
      })
    );
  };
};

export const getAllGatewaysService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/gateways", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const saveGatewayService = (data, id = 0) => {
  if (id > 0) {
    return async (dispatch, getState) => {
      return dispatch(
        request("/gateways/" + id, getState(), {
          method: "PUT",
          data,
        })
      );
    };
  }
  return async (dispatch, getState) => {
    return dispatch(
      request("/gateways", getState(), {
        method: "POST",
        data,
      })
    );
  };
};

export const deleteGatewayService = (id = 0) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/gateways/" + id, getState(), {
        method: "DELETE",
      })
    );
  };
};
